import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-project-retention',
  templateUrl: './edit-project-retention.component.html',
  styleUrls: ['./edit-project-retention.component.scss']
})
export class EditProjectRetentionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
